export function openWindow(url: string, target = '_blank') {
  window.open(url, target, 'noopener');
}
